import React, { Fragment } from 'react';

import classNames from 'classnames/bind';
import styles from './FloatingButton.scss';

const cx = classNames.bind(styles);

function FloatingButton({ renderLeft, renderRight }) {
  return (
    <>
      <div className={cx('empty-space')} />
      <div className={cx('FloatingButton')}>
        {renderLeft && <div className={cx('left')}>{renderLeft()}</div>}
        {renderRight && <div className={cx('right')}>{renderRight()}</div>}
      </div>
    </>
  );
}

export default FloatingButton;
